import React, { useEffect, useState } from "react";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import Grid from "components/common/Grid";
import Stack from "components/common/Stack";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Button from "components/common/Button";
import MenuItem from "components/common/MenuItem";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DropzoneArea } from "react-mui-dropzone";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import CancelIcon from "@mui/icons-material/Cancel";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import OutlinedInput from "@mui/material/OutlinedInput";
import { useHistory } from "react-router-dom";
import { Chip, CircularProgress } from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";

const EditStationForm = ({
  props,
  onSubmit,
  onChange,
  formData,
  onImageChange,
  isLoading,
  formError,
  DeleteAmenityChip,
  editData,
  onChengeUpdateAmenity,
  handleDeleteAttachment,
}) => {

  const [timeFormat, setTimeFormat] = useState("24hr");

  const handleTimeFormatChange = (event) => {
    setTimeFormat(event.target.value);
    if (event.target.value === "24hr") {
      let date = new Date();
      let Closedate = new Date();
      date.setHours(0, 0, 0, 0);
      onChange("open_time", date);
      Closedate.setHours(23, 59, 59, 59);
      onChange("close_time", Closedate);
      //  onChange("close_time","Thu Jul 25 2024 23:59:59 GMT+0530 (India Standard Time)")
    }
  };
  useEffect(() => {
    let date = new Date();
    let Closedate = new Date();
    date.setHours(0, 0, 0, 0);
    onChange("open_time", date);
    Closedate.setHours(23, 59, 59, 59);
    onChange("close_time", Closedate);
  }, []);
  const amenities = props.basicDetailData.amenities;
  const addAmenities = [...props.amenitiesData];
  const StationId = props.basicDetailData.stationId;
  const attachments = props.basicDetailData.attachments;

  let history = useHistory();
  const classes = useStyles();

  var network = props.networkData;
  var open_time = "12/12/2021 " + formData.open_time;
  var close_time = "12/12/2021 " + formData.close_time;

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const iconData = [];
  iconData.src = "../Group 20449/Group 20158.svg";
  const A = addAmenities;
  const B = amenities;
  const SelectAmenity = A?.filter((a) => !B?.map((b) => b.id).includes(a.id));

  return (
    <>
      {isLoading == true ? (
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: "300px" }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box className={classes.center}>
          <Breadcrumbs
            sx={{ fontSize: "14px", marginBottom: "20px", marginTop: "10px" }}
          >
            <Text
              onClick={() => history.goBack()}
              sx={{ fontSize: "14px", cursor: "pointer", color: "a2a2a2" }}
            >
              Charging Station
            </Text>
            <Text
              sx={{
                fontSize: "14px",
                color: "a2a2a2",
              }}
              color="text.primary"
            >
              Edit Station
            </Text>
          </Breadcrumbs>

          <Card>
            <CardContent>
              <Text
                variant="h5"
                color="#707070"
                sx={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "40px",
                }}
              >
                <ArrowBackIcon
                  sx={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                  onClick={() => history.goBack()}
                />
                {editData.chargingStationName}
              </Text>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{
                  marginBottom: "1.25rem",
                }}
              >
                <Grid container columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}>
                  <Grid item xs={12} sm={12} md={2} lg={3}>
                    <Text variant="body1" className={classes.formHeading}>
                      BASIC DETAILS
                    </Text>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={9}>
                    <Box className={classes.form_container}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Name of Charging Station"
                        value={formData.name}
                        onChange={(e) => onChange("name", e.target.value)}
                        helperText={formError.name}
                        error={formError.name}
                        InputLabelProps={{ style: { fontSize: 16 } }}
                        inputProps={{
                          style: {
                            textTransform: "capitalize",
                            fontSize: "14px",
                          },
                        }}
                      />

                      <Grid
                        container
                        columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                      >
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="outlined-basic"
                            label="Email id"
                            onChange={(e) => onChange("email", e.target.value)}
                            value={formData.email}
                            helperText={formError.email}
                            error={formError.email}
                            variant="outlined"
                            style={{ marginTop: "1.25rem" }}
                            InputLabelProps={{ style: { fontSize: 16 } }}
                            inputProps={{
                              style: {
                                textTransform: "lowercase",
                                fontSize: "14px",
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="outlined-basic"
                            label="Contact Number"
                            onChange={(e) => onChange("mobile", e.target.value)}
                            variant="outlined"
                            style={{ marginTop: "1.25rem" }}
                            value={formData.mobile}
                            error={formError.mobile}
                            helperText={formError.mobile}
                            InputLabelProps={{ style: { fontSize: 16 } }}
                            inputProps={{
                              style: { fontSize: "14px" },
                              maxLength: 10,
                              minLength: 10,
                            }}
                          />
                        </Grid>
                      </Grid>

                      <Box style={{ marginTop: "1.25rem" }}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Select type of network
                          </InputLabel>
                          <Select
                            sx={{ fontSize: "14px" }}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Select type of network"
                            value={formData.network_id}
                            onChange={(e) =>
                              onChange("network_id", e.target.value)
                            }
                            size="small"
                          >
                            {network?.map((network, i) => (
                              <MenuItem
                                sx={{ fontSize: "14px" }}
                                value={network.id}
                                key={i}
                              >
                                {network.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>

                      <FormControl
                        sx={{
                          top: "1.25rem",
                          marginBottom: "2.25rem",
                          width: "100% !important",
                        }}
                      >
                        <FormLabel
                          id="demo-row-radio-buttons-group-label"
                          sx={{
                            marginBottom: "10px",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          Type of Charging Station
                        </FormLabel>
                        <RadioGroup
                          row
                          value={formData.type}
                          defaultValue={formData.type}
                          onChange={(e) => onChange("type", e.target.value)}
                        >
                          <FormControlLabel
                            sx={{
                              ".MuiFormControlLabel-label": {
                                position: "relative",
                                margin: "auto",
                                fontSize: "14px",
                              },
                            }}
                            style={{
                              marginLeft: "0",
                              marginRight: "10%",
                              padding: "10px 0px",
                              width: "45%",
                              height: "20px",
                              border: "1px solid #e0e0e0",
                            }}
                            className={classes.form_option}
                            value="PUBLIC"
                            control={
                              <Radio
                                sx={{
                                  "&.Mui-checked": {
                                    color: "#6c757d",
                                  },
                                }}
                              />
                            }
                            label="Public"
                            labelPlacement="start"
                          />
                          <FormControlLabel
                            sx={{
                              ".MuiFormControlLabel-label": {
                                position: "relative",
                                margin: "auto",
                                fontSize: "14px",
                              },
                            }}
                            style={{
                              marginLeft: "0",
                              padding: "10px 0px",
                              width: "45%",
                              border: "1px solid #e0e0e0",
                              height: "20px",
                            }}
                            className={classes.form_option}
                            value="PRIVATE"
                            control={
                              <Radio
                                sx={{
                                  "&.Mui-checked": {
                                    color: "#6c757d",
                                  },
                                }}
                              />
                            }
                            labelPlacement="start"
                            label="Private"
                          />
                        </RadioGroup>
                      </FormControl>

                      <LocalizationProvider
                        style={{ marginTop: "1.25rem" }}
                        dateAdapter={AdapterDateFns}
                      >
                        <FormLabel
                          id="demo-row-radio-buttons-group-label"
                          sx={{
                            marginBottom: "10px",
                            marginTop: "1.25rem",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          Working Hours
                        </FormLabel>
                        <FormControl fullWidth style={{ marginTop: "1.25rem" }}>
                          <InputLabel id="time-format-label">
                            Time Format
                          </InputLabel>
                          <Select
                            size="small"
                            labelId="time-format-label"
                            value={timeFormat}
                            label="Time Format"
                            onChange={handleTimeFormatChange}
                          >
                            <MenuItem value="24hr">24 Hours</MenuItem>
                            <MenuItem value="custom">Custom</MenuItem>
                          </Select>
                        </FormControl>
                        <Grid
                          style={{ marginTop: "1.25rem" }}
                          container
                          columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                        >
                          <Grid item xs={5}>
                            <TimePicker
                              label="Open Time"
                              onChange={(e) => onChange("open_time", e)}
                              inputProps={{ style: { fontSize: "14px" } }}
                              value={open_time}
                              size="small"
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <FormLabel
                              id="demo-row-radio-buttons-group-label"
                              sx={{ margin: "1rem" }}
                            >
                              to
                            </FormLabel>
                          </Grid>
                          <Grid item xs={5}>
                            <TimePicker
                              label="Close Time"
                              size="small"
                              value={close_time}
                              onChange={(e) => onChange("close_time", e)}
                              inputProps={{ style: { fontSize: "14px" } }}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                            />
                          </Grid>
                        </Grid>
                      </LocalizationProvider>

                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Charging station URL"
                        variant="outlined"
                        onChange={(e) =>
                          onChange("station_url", e.target.value)
                        }
                        inputProps={{ style: { fontSize: "14px" } }}
                        value={formData.station_url}
                        helperText={formError.station_url}
                        error={formError.station_url}
                        style={{ marginTop: "1.25rem" }}
                        InputLabelProps={{ style: { fontSize: 16 } }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12} md={2} lg={3}>
                    <Text variant="body1" className={classes.formHeading}>
                      AMENITIES
                    </Text>
                  </Grid>
                  <Grid item xs={12} sm={12} md={10} lg={9}>
                    <Box className={classes.form_container}>
                      <Box>
                        <FormControl fullWidth size="small">
                          {SelectAmenity.length !== 0 ? (
                            <>
                              <InputLabel
                                sx={{ fontSize: "14px" }}
                                id="demo-multiple-checkbox-label"
                              >
                                Select Amenity
                              </InputLabel>

                              <Select
                                sx={{ fontSize: "14px" }}
                                labelId="demo-multiple-checkbox-label"
                                id="amenity"
                                input={<OutlinedInput label="Select Amenity" />}
                                MenuProps={MenuProps}
                                onChange={(e) =>
                                  onChengeUpdateAmenity(
                                    e.target.value,
                                    StationId
                                  )
                                }
                              >
                                {SelectAmenity?.map((amenity, index) => (
                                  <MenuItem
                                    sx={{ fontSize: "14px" }}
                                    value={amenity.id}
                                    key={index}
                                  >
                                    {amenity.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </>
                          ) : (
                            ""
                          )}
                        </FormControl>

                        {amenities?.length !== 0 ? (
                          <>
                            <Box
                              marginTop="15px"
                              sx={{
                                backgroundColor: "#ffffff",
                                border: "2px solid #E9E9E9",
                                padding: "15px",
                                flexWrap: "wrap",
                                borderRadius: "5px",
                                display: "flex",
                              }}
                            >
                              {amenities !== undefined
                                ? amenities?.map((amenity, index) => (
                                    <Box
                                      sx={{ width: "8rem", margin: "10px" }}
                                      key={index}
                                    >
                                      <Chip
                                        sx={{ fontSize: "14px" }}
                                        label={amenity.name}
                                        onDelete={() =>
                                          DeleteAmenityChip(
                                            amenity?.id,
                                            StationId,
                                            index
                                          )
                                        }
                                      />
                                    </Box>
                                  ))
                                : "!  No Amenity Selected"}
                            </Box>
                          </>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12} md={2} lg={3}>
                    <Text variant="body1" className={classes.formHeading}>
                      ADDRESS DETAILS
                    </Text>
                  </Grid>
                  <Grid item xs={12} sm={12} md={10} lg={9}>
                    <Box className={classes.form_container}>
                      <TextField
                        id="outlined-multiline-static"
                        label="Address 1"
                        sx={{
                          backgroundColor: "#ffffff",
                        }}
                        onChange={(e) => onChange("address", e.target.value)}
                        inputProps={{ style: { fontSize: "14px" } }}
                        value={formData.address}
                        error={formError.address}
                        helperText={formError.address}
                        multiline
                        rows={4}
                        fullWidth
                        InputLabelProps={{ style: { fontSize: 16 } }}
                      />

                      <TextField
                        fullWidth
                        id="outlined-multiline-static"
                        label="Address 2"
                        sx={{
                          backgroundColor: "#ffffff",
                        }}
                        onChange={(e) => onChange("address2", e.target.value)}
                        value={formData.address2}
                        error={formError.address2}
                        helperText={formError.address2}
                        multiline
                        rows={4}
                        inputProps={{ style: { fontSize: "14px" } }}
                        style={{ marginTop: "1.25rem" }}
                        InputLabelProps={{ style: { fontSize: 16 } }}
                      />

                      <Grid
                        container
                        columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                      >
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="outlined-basic"
                            label="Landmark"
                            variant="outlined"
                            onChange={(e) =>
                              onChange("landmark", e.target.value)
                            }
                            inputProps={{ style: { fontSize: "14px" } }}
                            value={formData.landmark}
                            helperText={formError.landmark}
                            error={formError.landmark}
                            style={{ marginTop: "1.25rem" }}
                            InputLabelProps={{ style: { fontSize: 16 } }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="outlined-basic"
                            label="Pin code"
                            variant="outlined"
                            onChange={(e) => onChange("pin", e.target.value)}
                            inputProps={{
                              style: { fontSize: "14px" },
                              maxLength: 6,
                              minLength: 6,
                            }}
                            value={formData.pin}
                            error={formError.pin}
                            helperText={formError.pin}
                            style={{ marginTop: "1.25rem" }}
                            InputLabelProps={{ style: { fontSize: 16 } }}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                      >
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="outlined-basic"
                            label="Street"
                            variant="outlined"
                            onChange={(e) => onChange("street", e.target.value)}
                            value={formData.street}
                            error={formError.street}
                            helperText={formError.street}
                            inputProps={{ style: { fontSize: "14px" } }}
                            style={{ marginTop: "1.25rem" }}
                            InputLabelProps={{ style: { fontSize: 16 } }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="outlined-basic"
                            label="City"
                            onChange={(e) => onChange("city", e.target.value)}
                            inputProps={{ style: { fontSize: "14px" } }}
                            value={formData.city}
                            error={formError.city}
                            helperText={formError.city}
                            variant="outlined"
                            style={{ marginTop: "1.25rem" }}
                            InputLabelProps={{ style: { fontSize: 16 } }}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                      >
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <Box style={{ marginTop: "1.25rem" }}>
                            <FormControl fullWidth>
                              <CountryDropdown
                                value={formData.country}
                                style={{
                                  backgroundColor: "rgb(255, 255, 255)",
                                  height: "38px",
                                  fontSize: "14px",
                                  padding: "8px",
                                  color: "rgba(0, 0, 0, 0.6)",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  border: "1px solid rgba(0, 0, 0, 0.3)",
                                }}
                                onChange={(e) => onChange("country", e)}
                              />
                            </FormControl>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <Box style={{ marginTop: "1.25rem" }}>
                            <FormControl fullWidth>
                              <RegionDropdown
                                country={formData.country}
                                value={formData.state}
                                style={{
                                  backgroundColor: "rgb(255, 255, 255)",
                                  height: "38px",
                                  fontSize: "14px",
                                  padding: "8px",
                                  color: "rgba(0, 0, 0, 0.6)",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  border: "1px solid rgba(0, 0, 0, 0.3)",
                                }}
                                onChange={(e) => onChange("state", e)}
                              />
                            </FormControl>
                          </Box>
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                      >
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="outlined-basic"
                            label="Longitude"
                            variant="outlined"
                            style={{ marginTop: "1.25rem" }}
                            InputLabelProps={{ style: { fontSize: 16 } }}
                            onChange={(e) =>
                              onChange("longitude", e.target.value)
                            }
                            value={formData.longitude}
                            error={formError.longitude}
                            helperText={formError.longitude}
                            inputProps={{
                              style: { fontSize: "14px" },
                              maxLength: 10,
                              minLength: 10,
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            size="small"
                            id="outlined-basic"
                            label="Latitude"
                            variant="outlined"
                            style={{ marginTop: "1.25rem" }}
                            InputLabelProps={{ style: { fontSize: 16 } }}
                            onChange={(e) =>
                              onChange("latitude", e.target.value)
                            }
                            value={formData.latitude}
                            error={formError.latitude}
                            helperText={formError.latitude}
                            inputProps={{
                              style: { fontSize: "14px" },
                              maxLength: 10,
                              minLength: 10,
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12} md={2} lg={3}>
                    <Text variant="body1" className={classes.formHeading}>
                      PHOTOS OF CHARGING STATION
                    </Text>
                  </Grid>
                  <Grid item xs={12} sm={12} md={10} lg={9}>
                    <Box
                      sx={{
                        border: "2px dashed #E9E9E9",
                        borderRadius: "5px",
                        padding: "1.25rem",
                        width: "54.1%",
                        marginLeft: "5.65%",
                        display: "block",
                        "@media (max-width:768px)": {
                          width: "67%",
                          margin: "20px 0 0 18px",
                        },
                      }}
                    >
                      <Box
                        className={classes.form_containerImg}
                        sx={{ display: "block" }}
                      >
                        <Stack direction="row" style={{ flexWrap: "wrap" }}>
                          {attachments?.map((attachment_url, index) => (
                            <Box key={index}>
                              <CancelIcon
                                sx={{
                                  position: "absolute",
                                  margin: "8px 0px 0px 38px",
                                }}
                                onClick={() =>
                                  handleDeleteAttachment(attachment_url.id)
                                }
                              />
                              <img
                                src={attachment_url.url}
                                alt="attachment not found"
                                style={{
                                  width: "55px",
                                  height: "55px",
                                  margin: "10px",
                                }}
                              />
                            </Box>
                          ))}
                        </Stack>
                      </Box>

                      <Box sx={{ width: "100%" }}>
                        <DropzoneArea
                          dropzoneParagraphClass={classes.dropzone}
                          sx={{ color: "#E9E9E9" }}
                          dropzoneText="Drag and drop or Browse"
                          dropzoneClass={classes.dropzone}
                          initialFiles={formData.attachments}
                          Icon={() => (
                            <CloudUploadIcon
                              sx={{ color: "#E9E9E9", fontSize: "5.5rem" }}
                            />
                          )}
                          acceptedFiles={[
                            "image/jpeg",
                            "image/png",
                            "image/bmp",
                          ]}
                          onChange={(file) => onImageChange(file)}
                          value={formData.attachments}
                        />
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={3}></Grid>
                  <Grid item xs={12} sm={12} md={10} lg={9}>
                    <Box className={classes.form_container}>
                      <Button
                        sx={{
                          width: "160px",
                          height: "40px",
                          fontSize: "14px",
                        }}
                        variant="contained"
                        color="primary"
                        onClick={() => onSubmit(StationId)}
                      >
                        Save Changes
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Stack>
            </CardContent>
          </Card>
        </Box>
      )}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  dropzone: {
    fontSize: "18px",
    border: "none",
    width: "104%",
    marginTop: "24px",
    "@media (max-width:768px)": {
      width: "100%",
      marginLeft: "-2px",
    },
  },
  formHeading: {
    fontSize: "16px",
    fontFamily: "Nunito Sans",
    fontWeight: "bold",
    color: "#1E1E1E",
    marginTop: "1.6rem",
  },

  form_container: {
    padding: "1.25rem",
    width: "60%",
    marginLeft: "3%",
    "@media (max-width:768px)": {
      width: "80%",
      margin: "0",
    },
  },
  form_containerImg: {
    padding: "1.25rem",
    width: "100%",
    marginLeft: "4.65%",
    "@media (max-width:768px)": {
      width: "100%",
      margin: "20px 0 0 18px",
    },
  },
}));
export default EditStationForm;
